import { ReactionStack } from './environment';
import { isFn } from './checkers';
import { batchEnd, batchStart, disposeBindingReactions, releaseBindingReactions, } from './reaction';
var Tracker = (function () {
    function Tracker(scheduler, name) {
        var _this = this;
        if (name === void 0) { name = 'TrackerReaction'; }
        this.track = function (tracker) {
            if (ReactionStack.indexOf(_this.track) === -1) {
                releaseBindingReactions(_this.track);
                try {
                    ReactionStack.push(_this.track);
                    batchStart();
                    if (isFn(tracker)) {
                        _this.results = tracker();
                    }
                }
                finally {
                    batchEnd();
                    ReactionStack.pop();
                }
            }
            return _this.results;
        };
        this.dispose = function () {
            disposeBindingReactions(_this.track);
        };
        this.track._scheduler = scheduler;
        this.track._name = name;
    }
    return Tracker;
}());
export { Tracker };
